import Vue from 'vue';
import 'core-js/stable';
import '@/common/styles/global.less';
import 'regenerator-runtime/runtime';
import layout from './layout/index.vue';
import router from './router';
import store from './store';
import { _get, _post, _put } from '@/common/request/index';
import { getScript } from '@/common/utils/get-script';
import { getCss } from '@/common/utils/get-css';
import eventLib from '@/common/utils/document-event';
import { getQueryVariable } from '@/common/utils/index';
// import { getEnv } from '@/common/utils/env';
import '@/common/utils/element-subcontract.ts'; // element-ui转包
import IconSvg from '@/common/components/Iconfont/IconSvg.vue';
// @ts-ignore
window.$_EventLib = eventLib;
import '@/common/utils/logout.ts';
Vue.config.productionTip = false;
// 注册cookie
import dd from 'dingtalk-jsapi';
import { initSentry } from 'src/utils/sentry';
import '@/utils/permission'; // permission control
// 处理时间的过滤器
Vue.use(require('vue-moment'));
import moment from 'moment';
moment.locale('zh_cn');
// @ts-ignore
Vue.prototype.$post = _post;
Vue.prototype.$get = _get;
Vue.prototype.$put = _put;
Vue.prototype.$getScript = getScript;
Vue.prototype.$getCss = getCss;
Vue.component('IconSvg', IconSvg);
// const isProd = process.env.NODE_ENV === 'production';
var env = process.env.npm_config_env;
initSentry();
if (process.env.NODE_ENV !== 'development') {
    // @ts-ignore
    window.LHBbigdata.init({
        isSpa: true,
        cha_type: 'PMS',
        extendOuterConfig: [{
                key: 'token',
                target: 'newPmsToken',
            }, {
                key: 'user_id',
                target: 'newPmsUserId',
            }, {
                key: 'tenant_id',
                target: 'newPmsCompanyId',
            }],
        extendMsgConfig: [{
                key: 'source',
                target: 'source',
            }, {
                key: 'company_id',
                target: 'newPmsCompanyId',
            }, {
                key: 'store_id',
                target: 'placeIds',
            }],
        si: 'pc',
        sendFunc: function (params, config) {
            try {
                if (env === 'PE') {
                    // @ts-ignore
                    window.LHBbigdata.xhrTool.send(config.logPathPro, params);
                }
                else {
                    // @ts-ignore
                    window.LHBbigdata.xhrTool.send(config.logPathPre, params);
                }
            }
            catch (err) { }
        },
    });
    // 线上环境不再提示接口请求被取消
    window.addEventListener('unhandledrejection', function (event) {
        if (event.reason && event.reason.message && event.reason.message.indexOf('您取消了请求') > -1) {
            event.preventDefault();
        }
    });
}
else {
    // 本地开发环境过滤 ResizeObserver loop limit exceeded 报错
    window.addEventListener('error', function (err) {
        var _a, _b;
        try {
            if (err.type === 'error') {
                var iframe = document === null || document === void 0 ? void 0 : document.querySelector('#webpack-dev-server-client-overlay');
                if (err.message.indexOf('ResizeObserver loop limit exceeded') > -1 || err.message.indexOf('ResizeObserver loop completed with undelivered notifications') > -1) {
                    (_b = (_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow.document) === null || _a === void 0 ? void 0 : _a.querySelector('#webpack-dev-server-client-overlay-div button')) === null || _b === void 0 ? void 0 : _b.click();
                }
            }
        }
        catch (_) { }
    });
    // 本地开发环境过滤 无意义 报错
    window.addEventListener('unhandledrejection', function (event) {
        var _a, _b;
        var iframe = document === null || document === void 0 ? void 0 : document.querySelector('#webpack-dev-server-client-overlay');
        if (event.reason && event.reason.message && event.reason.message.indexOf('您取消了请求') > -1) {
            (_b = (_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow.document) === null || _a === void 0 ? void 0 : _a.querySelector('#webpack-dev-server-client-overlay-div button')) === null || _b === void 0 ? void 0 : _b.click();
        }
    });
}
if (dd.env.platform !== 'notInDingTalk') {
    dd.ready(function () {
        var corpId = getQueryVariable('corpId');
        if (corpId) {
            Vue.prototype.$CORPID = corpId;
        }
    });
}
/** 事件传递 */
import VueBus from 'vue-bus';
Vue.use(VueBus);
import config from '@/config';
window.WKConfig = config;
Vue.prototype.WKConfig = config;
import { getPermissionByKey } from '@/utils/index.js';
Vue.prototype.$auth = getPermissionByKey;
// 虚拟滚动
import VueVirtualScroller from 'vue-virtual-scroller';
Vue.use(VueVirtualScroller);
// cdn引用的element版本没有empty组件
import Empty from 'element-ui/packages/empty/src/index.vue';
Vue.component('el-empty', Empty);
import DropdownMenu from 'element-ui/packages/dropdown/src/dropdown-menu.vue';
Vue.component('crm-dropdown-menu', DropdownMenu);
import Dialog from 'element-ui/packages/dialog/src/component.vue';
Vue.component('crm-dialog', Dialog);
import Select from 'element-ui/packages/select/src/select.vue';
Vue.component('crm-select', Select);
import Cascader from 'element-ui/packages/cascader/src/cascader.vue';
Vue.component('crm-cascader', Cascader);
import Popover from 'element-ui/packages/popover/src/main.vue';
Vue.component('crm-popover', Popover);
// @ts-ignore
import ToolTip from 'element-ui/packages/tooltip/src/main.js';
Vue.component('crm-tooltip', ToolTip);
// @ts-ignore
import Pagination from 'element-ui/packages/pagination/src/pagination.js';
Vue.component('crm-pagination', Pagination);
// @ts-ignore
import Message from 'element-ui/packages/message/index.js';
Vue.prototype.$crmMessage = Message;
// @ts-ignore
import MessageBox from 'element-ui/packages/message-box/index.js';
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
// @ts-ignore
import DatePicker from 'element-ui/packages/date-picker/src/picker/date-picker.js';
Vue.component('crm-date-picker', DatePicker);
/** 常用flex组件 */
import Flexbox from '@/components/Flexbox/Flexbox.vue';
import FlexboxItem from '@/components/Flexbox/FlexboxItem.vue';
Vue.component('flexbox', Flexbox);
Vue.component('flexbox-item', FlexboxItem);
import XrAvatar from '@/components/XrAvatar/index.vue';
Vue.component('xr-avatar', XrAvatar);
import CrmTable from '@/components/Table/table.vue';
Vue.component('CrmTable', CrmTable);
import FileUpload from '@/components/FileUpload/index.js';
Vue.use(FileUpload);
import WkFileSelect from '@/components/NewCom/WkFile/Select/main.js';
Vue.use(WkFileSelect);
import WkPreviewFile from '@/components/WkPreviewFile/main.js';
Vue.use(WkPreviewFile);
import WkImport from '@/components/WkImport/main.js';
Vue.use(WkImport);
import WkExport from '@/components/WkExport/main.js';
Vue.use(WkExport);
import * as filters from './filters/index'; // global filters
Object.keys(filters).forEach(function (key) {
    Vue.filter(key, filters[key]);
});
import vueNumeralFilterInstaller from './filters/vueNumeralFilter';
Vue.use(vueNumeralFilterInstaller, { locale: 'chs' });
// 限制数据数值
import inputLimit from '@/directives/inputLimit/index.js';
Vue.use(inputLimit);
/** 懒加载图片 */
import VueSrc from '@/directives/src/index.js';
Vue.directive('src', VueSrc);
// 自定义全局点击空白处组件
import clickoutside from '@/directives/clickoutside/index.js';
Vue.directive('clickoutside', clickoutside);
import elClickoutside from '@/directives/elClickoutside/index.js';
Vue.directive('elclickoutside', elClickoutside);
import permission from '@/directives/permission/index.js';
Vue.directive('permission', permission);
import empty from '@/directives/empty/index.js';
Vue.use(empty);
import debounce from '@/directives/clickDebounce/index.js';
Vue.use(debounce);
// 添加实例属性
// Object.assign(Vue.prototype, {
//   // formValidate: require('./utils/formValidate').default, // 表单验证
//   // $message: message
// });
new Vue({
    router: router,
    store: store,
    render: function (h) { return h(layout); },
}).$mount('#app');
